import styled from 'styled-components';

import { Card, Container, ContentGrid } from '@swordhealth/ui-corporate';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 64px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    padding-top: 32px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    gap: 16px;
    padding-bottom: 32px;
    padding-top: 72px;
    text-align: left;
  }
`;

export const Wrapper = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    display: flex;
  }
`;

export const StyledContentGrid = styled(ContentGrid)`
  row-gap: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_xl}px) {
    display: flex;
    flex-direction: column;
  }
`;

export const CustomContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  margin: auto;
  padding-top: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    row-gap: 40px;
    padding: 40px 40px 0 40px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.max_sm}px) {
    padding: 0 24px;
    row-gap: 32px;
  }
`;

export const StyledCard = styled(Card)`
  padding: 32px;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_sm}px) {
    padding: 24px;
    row-gap: 24px;
  }
`;
